import { render, staticRenderFns } from "./ReportPrivateFeedback.vue?vue&type=template&id=1f88a441&scoped=true&"
import script from "./ReportPrivateFeedback.vue?vue&type=script&lang=js&"
export * from "./ReportPrivateFeedback.vue?vue&type=script&lang=js&"
import style0 from "./ReportPrivateFeedback.vue?vue&type=style&index=0&id=1f88a441&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f88a441",
  null
  
)

export default component.exports